/**
 * Singleton para saber si el usuario actual es demo. Poblado desde
 * `App.tsx` cuando `useMyProfile()` resuelve. Se consume desde el
 * QueryClient mutation onError (que corre fuera del árbol React) para
 * decidir qué mensaje mostrar cuando RLS rechaza una escritura.
 */

let isDemo = false;

export function setIsDemoUser(value: boolean): void {
  isDemo = value;
}

export function getIsDemoUser(): boolean {
  return isDemo;
}

/**
 * `true` si el error de Supabase es una violación RLS. Cubre las dos
 * variantes: 42501 (Postgres) + mensaje explícito de PostgREST.
 */
export function isRlsDeniedError(err: unknown): boolean {
  if (!err) return false;
  const anyErr = err as { code?: string; message?: string };
  if (anyErr.code === '42501') return true;
  const msg = anyErr.message ?? String(err);
  return /row-level security/i.test(msg) || /insufficient.*privilege/i.test(msg);
}
